var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.514,
    height: 58.154,
    viewBox: "0 0 58.514 58.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "request",
    transform: "translate(0.107)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 26.719,
    cy: 26.719,
    r: 26.719,
    transform: "translate(-0.107 4.715)",
    fill: "#e7efff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.572,
    cy: 1.572,
    r: 1.572,
    transform: "translate(-0.107 3.143)",
    fill: "#00c99f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 2.358,
    cy: 1.572,
    rx: 2.358,
    ry: 1.572,
    transform: "translate(51.759)",
    fill: "#ffa100"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 1.621,
    cy: 1.621,
    rx: 1.621,
    ry: 1.621,
    transform: "translate(55.165 46.989)",
    fill: "#00c99f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 1.572,
    cy: 1.572,
    r: 1.572,
    transform: "translate(1.464 55.01)",
    fill: "#ff4d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11233",
    "data-name": "Path 11233",
    d: "M53.977,13.563V52.795a27.049,27.049,0,0,1-8.206,6.148H22.206A27.049,27.049,0,0,1,14,52.795V8.161A2.161,2.161,0,0,1,16.161,6H46.414Z",
    transform: "translate(-6.916 -3.299)",
    fill: "#a5bced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11234",
    "data-name": "Path 11234",
    d: "M81.563,13.563H75.08A1.08,1.08,0,0,1,74,12.483V6Z",
    transform: "translate(-34.502 -3.299)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 1.572,
    cy: 1.572,
    r: 1.572,
    transform: "translate(10.895 31.434)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11236",
    "data-name": "Path 11236",
    d: "M56.31,61.08H32.54a.54.54,0,1,1,0-1.08H56.31a.54.54,0,0,1,0,1.08Z",
    transform: "translate(-15.191 -28.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 1.572,
    cy: 1.572,
    r: 1.572,
    transform: "translate(10.895 36.15)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11237",
    "data-name": "Path 11237",
    d: "M56.31,71.08H32.54a.54.54,0,1,1,0-1.08H56.31a.54.54,0,0,1,0,1.08Z",
    transform: "translate(-15.191 -32.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 1.572,
    cy: 2.358,
    rx: 1.572,
    ry: 2.358,
    transform: "translate(10.895 40.865)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11238",
    "data-name": "Path 11238",
    d: "M56.31,81.08H32.54a.54.54,0,1,1,0-1.08H56.31a.54.54,0,1,1,0,1.08Z",
    transform: "translate(-15.191 -37.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1.572,
    cy: 1.572,
    r: 1.572,
    transform: "translate(10.895 47.152)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11239",
    "data-name": "Path 11239",
    d: "M56.31,91.08H32.54a.54.54,0,1,1,0-1.08H56.31a.54.54,0,1,1,0,1.08Z",
    transform: "translate(-15.191 -41.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11240",
    "data-name": "Path 11240",
    d: "M0,0H4.322V16.207H0Z",
    transform: "translate(52.449 20.473) rotate(26.873)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241",
    "data-name": "Path 11241",
    d: "M76,89.342a.54.54,0,0,1-.238-.724L76,88.137a.54.54,0,1,1,.962.486l-.243.481A.54.54,0,0,1,76,89.342Z",
    transform: "translate(-35.285 -40.91)",
    fill: "#4e6aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11242",
    "data-name": "Path 11242",
    d: "M1.08,0h1.08a1.08,1.08,0,0,1,1.08,1.08v2.7H0V1.08A1.08,1.08,0,0,1,1.08,0Z",
    transform: "translate(54.636 17.346) rotate(26.873)",
    fill: "#323fd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11243",
    "data-name": "Path 11243",
    d: "M80.133,83.666l-2.912,2.156-.962-.486.016-3.625Z",
    transform: "translate(-35.541 -38.108)",
    fill: "#8fa2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11244",
    "data-name": "Path 11244",
    d: "M94.887,54.6a.54.54,0,0,1-.076-.918c.816-.605.848-.605.924-.756l5.5-10.853a.54.54,0,0,0-.238-.729L96.178,38.9a.54.54,0,1,1,.492-.962l4.819,2.442a1.621,1.621,0,0,1,.713,2.161L96.7,53.421c-.232.448-.54.61-1.248,1.134A.54.54,0,0,1,94.887,54.6Z",
    transform: "translate(-43.969 -17.955)",
    fill: "#8fa2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11245",
    "data-name": "Path 11245",
    d: "M94.973,50.675a.54.54,0,0,1-.243-.729l.978-1.929a.542.542,0,1,1,.967.492L95.7,50.438A.54.54,0,0,1,94.973,50.675Z",
    transform: "translate(-44.006 -22.481)",
    fill: "#323fd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M0,0H4.322V9.724H0Z",
    transform: "translate(45.124 34.93) rotate(26.873)",
    fill: "#323fd4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9528",
    "data-name": "Group 9528"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(18.648 7.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-right",
    "data-name": "Icon awesome-arrow-alt-circle-right",
    d: "M9.886.563A9.323,9.323,0,1,1,.563,9.886,9.322,9.322,0,0,1,9.886.563ZM5.525,11.54H9.886v2.665a.451.451,0,0,0,.771.32l4.3-4.32a.447.447,0,0,0,0-.635l-4.3-4.323a.451.451,0,0,0-.771.32V8.232H5.525a.452.452,0,0,0-.451.451v2.406A.452.452,0,0,0,5.525,11.54Z",
    transform: "translate(17.895 6.031)",
    fill: "#ff8d5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingIcon);
export default __webpack_public_path__ + "static/media/outgoing-icon.a8383933853a5d018fbcf041aecf7029.svg";
export { ForwardRef as ReactComponent };